import { getGridNumericOperators } from '@mui/x-data-grid-pro';

export const getNumericOperators = (exceptions = []) => {
	return getGridNumericOperators().filter(
		operator =>
			operator.value !== 'isEmpty' && operator.value !== 'isNotEmpty' && !exceptions.includes(operator.value),
	);
};
